<template>
	<div class="content-wrapper">
		<div class="sf-flex-column">
			<!-- 조회부분 시작 -->
			<div class="sf-col sf-col-7">
				<sf-card class="p-0 h-100 card_bg">
					<pc-qrty-search ref="search" :scrId="scrId" />
				</sf-card>
			</div>
			<!-- 조회부분 끝 -->

			<!-- 그래프 부분 시작 -->
			<div class="sf-col sf-col-12">
				<sf-card class="p-0 border-0 bg-transparent">
					<pc-qrty-graph ref="graph" @Refresh="Refresh" :scrId="scrId"></pc-qrty-graph>
				</sf-card>
			</div>
			<!-- 그래프 부분 끝 -->
			<!-- 그리드 부분 시작 -->
			<div class="sf-col sf-col-10">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<pc-qrty-table ref="table" @Refresh="Refresh" :scrId="scrId"></pc-qrty-table>
				</sf-card>
			</div>
			<!-- 그리드 부분 시작 -->
		</div>
	</div>
</template>

<script>
import PcQrtySearch from './Search/PcQrtySearch.vue';
import PcQrtyTable from './Table/PcQrtyTable.vue';
import PcQrtyGraph from './Table/PcQrtyGraph.vue';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {};
	},
	created() {
		console.clear();
	},
	components: { PcQrtySearch, PcQrtyTable, PcQrtyGraph },
	methods: {
		Refresh(currentPage = 1, pageUnit = 30) {
			this.$refs.search.searchList(currentPage, pageUnit);
		}
	}
};
</script>

<style></style>
